import React from "react";
import styles from "./Header.module.scss"
import {Container} from "react-bootstrap";
import NavBar from "./NavBar";
import HeaderBanner from "./HeaderBanner";

const Header: React.FC = () => {
    return (
        <header className={styles.header}>
            <Container>
                <NavBar/>
                <HeaderBanner/>
            </Container>
        </header>
    )
}

export default Header;